<template>
  <div>
    <el-form-item
      :label="field.name + '：'"
      label-width="110px"
      id="image-list"
    >
      <div class="item-list">
        <draggable v-model="config[field.key]">
          <el-row
            class="item"
            v-for="(item, index) in config[field.key]"
            :key="index"
            type="flex"
            justify="space-between"
          >
            <div
              class="link-name"
              v-text="config[field.key][index]['item_id']+'-'+config[field.key][index]['item_name']"
            ></div>
            <el-button
              size="small"
              @click="removeArticleItem(index)"
              class="del-btn"
              >删除</el-button
            >
          </el-row>
        </draggable>
        <el-button size="small" @click="openDialog">添加商品</el-button>
      </div>
    </el-form-item>
    <el-dialog
      title="请选择商品"
      :visible.sync="dialog.visible"
      @close="closeDialog"
    >
      <active-goods-list
        :url="tableList.url"
        ref="item_list"
        @close="closeDialog"
        :multi="tableList.multi"
        :params="tableList.params"
        :idList="idList"
        @unSelect="unSelect"
        @select="select"
        :pageData="pageData"
        @allSelect="allSelect"
      ></active-goods-list>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.item-list {
  margin-top: -5px;
}
.item {
  cursor: pointer;
  padding: 5px 5px 5px 10px;
  &:hover {
    background: #f5f7fa;
  }
}
.link-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  padding-right: 20px;
}
.del-btn {
  height: 32px;
  margin-top: 4px;
}
</style>

<script>
import Util from "@/js/util";
import _ from "lodash";
import draggable from "vuedraggable";
export default {
  name: "tms-type-active-goods-item",
  props: {
    field: {
      type: [Object, Array],
      required: true,
    },
    source: {
      type: String,
    },
    // config: {
    //   type: Object,
    //   default() {
    //     return {}
    //   }
    // },
    // pageData: {
    //   type: Object,
    //   default() {
    //     return {}
    //   }
    // }
  },
  data() {
    return {
      dialog: {
        visible: false,
      },
      linkNameList: {},
      sliceCount: 0,
      currentIndex: 0,
      activeName: "normal",
      tableList: {
        url: "ec/b/operation/buyer/item/list",
        multi: true,
        params: {},
      },
      isSelectActive: false,
    };
  },

  computed: {
    idList() {
      let list = [];
      this.config[this.field.key].map((val) => {
        list.push(val.id);
      });

      return list;
    },
    config() {
      if (this.source === "tmsPageConfig") {
        return this.$store.state.tms.pageData;
      }
      if (this.source === "tmsModuleConfig") {
        return this.$store.state.tms.config;
      }
      return this.$store.state.tms.customConfig;
    },
    pageData() {
      return this.$store.state.tms.pageData;
    },
  },
  watch: {
    config: {
      handler(val) {
        this.isSelectActive = !!val.active_item.id;
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    draggable,
  },

  created() {
    if (this.pageData.app_type == "seller") {
      console.log("选择卖家商品");
    } else {
      console.log("选择买家商品");
    }
  },

  methods: {
    openDialog() {
      this.dialog.visible = true;
    },
    // 通过活动ID获取对应的推荐清单

    async getDetailedList() {
      const res = await lib.api.get({
        api: "ec/b/operation/activity/statistics/type/data/get",
        data: { activity_id: this.config.active_item.id },
        success: (res) => {
          this.tableList.params = {
            id: res.data.data[0],
          };
          this.config.property_data.recommend_id = res.data.data[0];
        },
        error: (data) => {
          if (data.code == 50004) {
            lib.login.goLogin();
          }
          this.$message.error(data.msg || "请求失败!");
        },
        complete: () => {},
      });
    },
    removeArticleItem(index) {
      let row = this.config[this.field.key].splice(index, 1)[0];
      if (this.$refs.item_list) {
        this.$refs.item_list.removerIdList(row.id);
      }
    },
    handleUpload(src, index) {
      this.$set(this.config[this.field.key][index], image_url, src);
    },
    openDialog() {
      if (!this.isSelectActive) {
        this.$message.error("请先选择活动");
        return;
      }
      this.getDetailedList();
      // this.currentIndex = index;
      this.dialog.visible = true;
    },
    closeDialog() {
      this.dialog.visible = false;
    },
    select(row) {
      let item = _.cloneDeep(row);
      delete item.detail;
      // console.log(item, "选取的商品");
      item.cms_url = "/cms/page/biz/item.html?id=" + item.id;
      item.promotion_price = Util.filterPriceToFen(item.promotion_price);
      this.config[this.field.key].push(item);
      console.log(this.$store.state.tms, "接受选择的商品");
    },
    unSelect(row, index) {
      this.config[this.field.key].splice(index, 1);
    },
    allSelect(value) {
      let section = _.cloneDeep(value);
      if (value.length > 0) {
        section.forEach((v, i) => {
          section[i].cms_url = "/cms/page/biz/item.html?id=" + v.id;
          section[i].promotion_price = Util.filterPriceToFen(v.promotion_price);
          this.sliceCount++;
        });
        section.forEach((v, i) => {
          if (!this.config.link_data[i]) {
            this.config[this.field.key].push(v);
          }
        });
      } else {
        this.config[this.field.key].splice(-this.sliceCount);
        this.sliceCount = 0;
      }
    },
  },
};
</script>
